const getOldVersionUrl = () => {
  const { origin } = window.location;

  return origin.replace(/(new\.|prev\.)/g, '');
};

export default getOldVersionUrl;
